import clsx from "clsx";
import React from "react"


const estilosBotoes = require("../../../estilos/botoes.module.scss").default;
const estilosInputs = require('../../../estilos/inputs.module.scss').default

export type ConfirmarEtapaProducaoProps = {
    onOk: () => void
}

export const ConfirmarEtapaProducao = (props: ConfirmarEtapaProducaoProps) => {
    return (
        <>
            <div className="_mt-4 _mb-8">
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Etapa de produção</label>
                    <input
                        type="text"
                        className={clsx("_w-[300px]", estilosInputs.inputPadrao)}
                    />
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Execução</label>
                    <input
                        type="text"
                        className={clsx("_w-[100px]", estilosInputs.inputPadrao)}
                    />
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Operador</label>

                    <select
                        className={clsx("_w-[300px]", estilosInputs.inputPadrao)}

                    >
                    </select>
                </div>
            </div>

            <div className="_my-4">
                <div className="_justify-between">
                    <div className="_my-4">
                        <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                            onClick={() => { props.onOk() }}
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}